import { Trans } from "@lingui/macro";
import { useWeb3React } from "@web3-react/core";
import React, { useCallback, useEffect } from "react";
import "./Header.css";
import { getAccountUrl, isHomeSite } from "lib/legacy";
import AddressDropdown from "../AddressDropdown/AddressDropdown";
import NetworkDropdown from "../NetworkDropdown/NetworkDropdown";
import LanguagePopupHome from "../NetworkDropdown/LanguagePopupHome";
import { CANTO, getChainName } from "config/chains";
import { switchNetwork } from "lib/wallets";
import { useChainId } from "lib/chains";
import { isDevelopment } from "config/env";
import { getIcon } from "config/icons";
import { ConnectWalletButton } from "../Common/ConnectWalletButton/ConnectWalletButton";
import { UseBreakpoints } from "../../hooks/useBreakpoints";
import classes from "./Header.module.scss";

type Props = {
  setWalletModalVisible: (visible: boolean) => void;
  disconnectAccountAndCloseSettings: () => void;
};
export function AppHeaderUser({ setWalletModalVisible, disconnectAccountAndCloseSettings }: Props) {
  const { chainId } = useChainId();
  const { active, account } = useWeb3React();
  const showConnectionOptions = !isHomeSite();
  const { isMobile } = UseBreakpoints();

  if (!active || !account) {
    return (
      <div>
        {showConnectionOptions ? (
          <ConnectWalletButton onClick={() => setWalletModalVisible(true)}>
            {<Trans>Connect Wallet</Trans>}
          </ConnectWalletButton>
        ) : (
          <LanguagePopupHome />
        )}
      </div>
    );
  }

  const accountUrl = getAccountUrl(chainId, account);

  return (
    <div className={classes.dropDownsWrapper}>
      {showConnectionOptions ? (
        <>
          <AddressDropdown
            account={account}
            accountUrl={accountUrl}
            disconnectAccountAndCloseSettings={disconnectAccountAndCloseSettings}
          />
        </>
      ) : (
        <LanguagePopupHome />
      )}
    </div>
  );
}
